import { AfterViewInit, Directive, ElementRef, Input, } from '@angular/core';

@Directive({
	selector: '[appAutoFocus]',
	standalone: false,
})
export class FocusDirective implements AfterViewInit {
	constructor(public element: ElementRef<HTMLElement>) {
	}

	ngAfterViewInit(): void {
		setTimeout(() => this.element.nativeElement.focus(), 0);
	}
}
